import { render } from "./datatable.vue?vue&type=template&id=a7b49e7c&scoped=true"
import script from "./datatable.vue?vue&type=script&lang=js"
export * from "./datatable.vue?vue&type=script&lang=js"

import "./datatable.vue?vue&type=style&index=0&id=a7b49e7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7b49e7c"]])

export default __exports__